import {createAction, props} from "@ngrx/store";
import {ActionType} from "@/main/autoreg/accounts/store/action.type";

export const updateToLocalStorageProxyAndGroupFBAction = createAction(
  ActionType.UPDATE_TO_LOCAL_STORAGE_GROUP_PROXY_FB,
  props<{proxy?: number, group?: number}>()
)
